import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUser, createUser, updateUser, fetchUserMapping, createUserMapping, updateUserMapping, requestPasswordReset, requestPasswordResetUrl } from './actions';
import UserSettingsForm from './SettingsForm';
import UserMappingForm from './UserMappingForm';
import authUtils from '../../auth/utils';
import { loadUnpagedRoles } from '../roles/actions';
import { loadUnpagedFranchisees } from '../franchisees/actions';
import { withTranslation } from 'react-i18next';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import Dialog from '../../common/components/Dialog';
import { Link } from 'react-router-dom';
import utils from '../../common/services/utils';
import { Panel } from 'react-bootstrap';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleUserSettingsSubmit = this.handleUserSettingsSubmit.bind(this);
		this.handleUserMappingSubmit = this.handleUserMappingSubmit.bind(this);
		this.handleRequestPasswordReset = this.handleRequestPasswordReset.bind(this);
		this.handleRequestPasswordResetUrl = this.handleRequestPasswordResetUrl.bind(this);
		this.handleRestrictedToChange = this.handleRestrictedToChange.bind(this);
		this.state = {
			showResetPasswordUrl: false,
			resetPasswordUrl: '',
			restrictedTo: null,
			// the form's own submitSucceeded cannot be used here: saving changes the stored mapping,
			// which makes enableReinitialize fire INITIALIZE and that clears the flag
			userMappingSaved: false
		};
	}

	componentDidMount() {
		const { match, fetchUser, fetchUserMapping } = this.props;
		const userId = match.params.id;

		this.loadRoles();
		this.loadFranchisees();

		if (userId) {
			fetchUser(userId);
			fetchUserMapping(userId);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.userMapping && this.state.restrictedTo == null) {
			const restrictedTo = nextProps.userMapping.centerId ? '2' : (nextProps.userMapping.franchiseeId ? '1' : '0')
			this.setState({ restrictedTo })
		}
	}

	handleRestrictedToChange(event, restrictedTo) {
		this.setState({ restrictedTo, userMappingSaved: false });
	}

	handleUserSettingsSubmit(values) {
		const { user, createUser, updateUser, history } = this.props;
	
		if (user) {
			updateUser(user.id, values);
		} else {
			createUser(values, history);
		}
	}

	handleUserMappingSubmit(values) {
		const { userMapping, createUserMapping, updateUserMapping, history, userId } = this.props;
		switch (values.restrictedTo) {
			case '0':
				values.centerId = null;
				values.franchiseeId = null;
				break;
			case '1':
				values.centerId = null;
				break;
			case '2':
				values.franchiseeId = null;
				break;
		}
		const onSuccessEvent = () => this.setState({ userMappingSaved: true });

		if (userMapping) {
			updateUserMapping(userMapping.id, values, onSuccessEvent);
		} else {
			values.systemUserId = userId;
			createUserMapping(values, history, onSuccessEvent);
		}
	}

	handleRequestPasswordReset() {
		this.props.requestPasswordReset(this.props.userId);
	}

	handleRequestPasswordResetUrl() {
		const onSuccessEvent = (resetPasswordUrl) => {
			this.setState({
				showResetPasswordUrl: true,
				resetPasswordUrl: resetPasswordUrl.url
			});
		};
		this.props.requestPasswordResetUrl(this.props.userId, onSuccessEvent);
	}

	loadRoles() {
		const { loadUnpagedRoles } = this.props;
		loadUnpagedRoles();
	}

	loadFranchisees() {
		const { loadUnpagedFranchisees } = this.props;
		loadUnpagedFranchisees();
	}

	renderUserMapping() {
		const { userMapping, user, t, isReadonly, franchisees } = this.props;
		
		if (userMapping) {
			return <UserMappingForm form='userMappingForm' isReadonly={isReadonly} onSubmit={this.handleUserMappingSubmit}
				initialValues={{ ...userMapping, restrictedTo: this.state.restrictedTo }}
				franchisees={franchisees}
				restrictedToChange={this.handleRestrictedToChange}
				saveSucceeded={this.state.userMappingSaved}
				restrictedTo={this.state.restrictedTo} />;
		}
		else {
			return <UserMappingForm form='userMappingForm' isReadonly={isReadonly} onSubmit={this.handleUserMappingSubmit}
				franchisees={franchisees} restrictedToChange={this.handleRestrictedToChange}
				saveSucceeded={this.state.userMappingSaved}
				restrictedTo={this.state.restrictedTo} initialValues={{restrictedTo: '0'}}/>;
		}
	}

	renderResetPasswordUrlDialog() {
		const { t } = this.props;

		const dialogConfig = {
			header: t('User_ResetPasswordUrl'),
			body: this.state.resetPasswordUrl,
			onHide: () => this.setState({ showResetPasswordUrl: false })
		};
		return <Dialog config={dialogConfig} show={this.state.showResetPasswordUrl} />;
	}

	render() {
		const { user, isReadonly, roles, t } = this.props;
		const userMappingForm = this.renderUserMapping();


		if (user) {
			const isParent = user && user.role && user.role.name == 'Parent';
			const resetPasswordUrlDialog = this.renderResetPasswordUrlDialog();
			return (
				<div className='mb-1'>
					<CollapsablePanel title={t('User_UserDetails')} >
						<UserSettingsForm form='user' isReadonly={isReadonly} onSubmit={this.handleUserSettingsSubmit} initialValues={user} roles={roles}
							onRequestPasswordReset={this.handleRequestPasswordReset} onRequestPasswordResetUrl={this.handleRequestPasswordResetUrl} />
						{resetPasswordUrlDialog}
					</CollapsablePanel>
					{!isParent && <CollapsablePanel title={t('User_UserMapping')} >
						{userMappingForm}
					</CollapsablePanel>}
					<Link to='/users' className='btn btn-default'>{t('Common_BackToList')}</Link>
				</div>
			);
		} else {
			let newUserRoles = utils.filter(roles, r => r.name !== 'Teacher' && r.name !== 'Parent');
			return <Panel>
				<Panel.Heading>{t('User_UserDetails')}</Panel.Heading>
				<Panel.Body>
					<UserSettingsForm form='newUser' isReadonly={isReadonly} onSubmit={this.handleUserSettingsSubmit} roles={newUserRoles} />
				</Panel.Body>
			</Panel>;
		}
	}
}

const mapStateToProps = (state, ownProps) => {
	const userId = ownProps.match.params.id;

	const {
		entities: { users, roles, franchisees, userMappings },
		auth: { currentUser }
	} = state;

	return {
		user: users[userId],
		userMapping: userMappings[userId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Users'),
		roles: roles,
		franchisees: franchisees,
		userId: userId
	};
};

export default connect(mapStateToProps, {
	fetchUser,
	fetchUserMapping,
	createUser,
	updateUser,
	createUserMapping,
	updateUserMapping,
	requestPasswordReset,
	requestPasswordResetUrl,
	loadUnpagedRoles,
	loadUnpagedFranchisees
})(withTranslation()(Details));